import { playgroundApi } from '../../common/api-client';
import {
  BaseMonthlyPolicyRow, BasePolicyRow, Coverages, PremiumBreakdown, SimulationWarning,
  buildRatePayload,
} from '../_shared';
import { APVHorizonteFormValues } from './schema';

export const PRODUCT = 'APV_HORIZONTE';

export interface APVHorizontePolicyRow extends BasePolicyRow {
  fiscal_contributions?: number;
}

export interface APVHorizonteMonthlyRow extends BaseMonthlyPolicyRow {
  fiscal_contributions?: number;
}

export interface APVHorizonteResponse {
  coverages: Coverages;
  currency: string;
  uf_value: number;
  premium: PremiumBreakdown;
  monthly_pension_with_afp: number;
  monthly_pension_afp_with_apv_transfer: number;
  monthly_pension_afp_apv_transfer_and_bice: number;
  total_monthly_projected_pension: number;
  total_afp_savings: number;
  total_apv_savings: number;
  total_savings: number;
  projection_by_year: APVHorizontePolicyRow[];
  projection_by_month?: APVHorizonteMonthlyRow[];
  warnings?: SimulationWarning[];
}

export interface SimulateParams {
  values: APVHorizonteFormValues;
}

export function buildAPVHorizontePayload(values: APVHorizonteFormValues) {
  const {
    rate_mode: _rateMode,
    projection_rate: _projectionRate,
    projection_rate_schedule: _projectionRateSchedule,
    direct_contribution_amount,
    direct_contribution_month,
    ...rest
  } = values;
  const direct_contribution = direct_contribution_amount > 0
    ? { amount: direct_contribution_amount, kind: 'UNIQUE', month: direct_contribution_month }
    : undefined;
  return {
    ...rest,
    ...buildRatePayload(values),
    ...(direct_contribution ? { direct_contribution } : {}),
  };
}

export async function simulateAPVHorizonte({
  values,
}: SimulateParams): Promise<APVHorizonteResponse> {
  const payload = {
    product: PRODUCT, ...buildAPVHorizontePayload(values), origin_process_id: 1, debug: true,
  };
  const { data } = await playgroundApi.post<APVHorizonteResponse>(
    'projection/',
    payload,
  );
  return data;
}
